import { BIND_TEMPLATE, CREATE_AND_BIND_TEMPLATE, CREATE_TEMPLATE, PARK_SKYFIRE_METHOD, TEMPLATE_RENDERED, URL_CHANGE, } from '../actions';
import { recordPageView } from '../utils/cloudwatchRumUtils';
import Performance from '../utils/performance';
import { reportPagePerformance } from '../utils/reportClientMetrics';
const getTemplateId = (action) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return ((_c = (_b = (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.template) === null || _b === void 0 ? void 0 : _b.innerTemplate) === null || _c === void 0 ? void 0 : _c.id) ||
        ((_e = (_d = action === null || action === void 0 ? void 0 : action.payload) === null || _d === void 0 ? void 0 : _d.template) === null || _e === void 0 ? void 0 : _e.id) ||
        ((_j = (_h = (_g = (_f = action === null || action === void 0 ? void 0 : action.payload) === null || _f === void 0 ? void 0 : _f.method) === null || _g === void 0 ? void 0 : _g.template) === null || _h === void 0 ? void 0 : _h.innerTemplate) === null || _j === void 0 ? void 0 : _j.id);
};
const getDeeplink = (action) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return ((_d = (_c = (_b = (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.template) === null || _b === void 0 ? void 0 : _b.innerTemplate) === null || _c === void 0 ? void 0 : _c.templateData) === null || _d === void 0 ? void 0 : _d.deeplink) ||
        ((_g = (_f = (_e = action === null || action === void 0 ? void 0 : action.payload) === null || _e === void 0 ? void 0 : _e.template) === null || _f === void 0 ? void 0 : _f.templateData) === null || _g === void 0 ? void 0 : _g.deeplink);
};
export const PagePerformanceMiddleware = (store) => (next) => (action) => {
    var _a, _b, _c;
    let { coldStart } = store.getState().TemplateStack;
    next(action);
    const templateId = getTemplateId(action);
    const deeplink = getDeeplink(action) || '';
    switch (action.type) {
        case CREATE_TEMPLATE:
            if (templateId) {
                Performance.mark(`request:${templateId}`);
                Performance.mark(`create:${templateId}`);
                if (coldStart) {
                    Performance.mark('cold-page-start');
                }
            }
            break;
        case CREATE_AND_BIND_TEMPLATE:
            if (templateId) {
                // Same logic as CREATE_TEMPLATE
                Performance.mark(`request:${templateId}`);
                // Same logic as BIND_TEMPLATE
                Performance.mark(`request:done:${templateId}`);
                Performance.mark(`render:${templateId}`);
                Performance.mark(`createAndBind:${templateId}`);
            }
            break;
        case BIND_TEMPLATE:
            if (templateId) {
                Performance.mark(`request:done:${templateId}`);
                Performance.mark(`render:${templateId}`);
                Performance.mark(`bind:${templateId}`);
                if (coldStart) {
                    Performance.measure('cold-request', `request:${templateId}`, `request:done:${templateId}`);
                }
            }
            break;
        case PARK_SKYFIRE_METHOD:
            if (templateId) {
                Performance.clearMarks(`request:${templateId}`);
                Performance.clearMarks(`request:done:${templateId}`);
                Performance.clearMarks(`render:${templateId}`);
                Performance.clearMarks(`create:${templateId}`);
                Performance.clearMarks(`bind:${templateId}`);
                Performance.clearMarks(`createAndBind:${templateId}`);
            }
            break;
        case TEMPLATE_RENDERED:
            if (templateId) {
                if (Performance.hasMark(`render:${templateId}`)) {
                    const id = templateId.split('_').pop();
                    Performance.measure(`page:${id}`, `request:${templateId}`);
                    Performance.measure(`render:${id}`, `render:${templateId}`);
                    Performance.measure(`request:${id}`, `request:${templateId}`, `request:done:${templateId}`);
                    let pageEntry = Performance.getEntriesByName(`page:${id}`).pop();
                    const renderEntry = Performance.getEntriesByName(`render:${id}`).pop();
                    let requestEntry = Performance.getEntriesByName(`request:${id}`).pop();
                    if (coldStart && (requestEntry === null || requestEntry === void 0 ? void 0 : requestEntry.duration) === 0) {
                        Performance.measure('cold-page', 'cold-page-start');
                        pageEntry = Performance.getEntriesByName('cold-page').pop();
                        requestEntry = Performance.getEntriesByName('cold-request').pop();
                    }
                    if (renderEntry !== undefined && pageEntry !== undefined) {
                        window.sessionStorage.setItem(templateId, String(Math.round(pageEntry.duration)));
                    }
                    if (pageEntry && renderEntry && requestEntry) {
                        const summary = {
                            page: pageEntry,
                            render: renderEntry,
                            request: requestEntry,
                        };
                        Performance.reportPageLatency(summary, deeplink, store.getState().Authentication);
                        Performance.reportMeskPerformanceLatency(summary, deeplink, store.getState().Authentication, store.getState().Storage);
                        Performance.reportParameterizedInterfaceLatency(summary, deeplink, store.getState().Authentication, store.getState().Storage);
                        Performance.clearMeasures();
                    }
                }
                else {
                    window.sessionStorage.setItem(templateId, '0');
                }
                // Report to client metrics lambda
                if (Performance.hasMark(`create:${templateId}`) ||
                    Performance.hasMark(`createAndBind:${templateId}`)) {
                    const id = templateId.split('_').pop();
                    const isCreateAndBind = Performance.hasMark(`createAndBind:${templateId}`);
                    if (isCreateAndBind) {
                        Performance.measure(`total:${id}`, `createAndBind:${templateId}`);
                    }
                    else {
                        Performance.measure(`create:${id}`, `create:${templateId}`, `bind:${templateId}`);
                        Performance.measure(`bind:${id}`, `bind:${templateId}`);
                        Performance.measure(`total:${id}`, `create:${templateId}`);
                    }
                    const pageEntry = Performance.getEntriesByName(`total:${id}`).pop();
                    const requestEntry = Performance.getEntriesByName(`create:${id}`).pop();
                    const renderEntry = Performance.getEntriesByName(`bind:${id}`).pop();
                    if (pageEntry) {
                        let pageEntryDuration = pageEntry.duration;
                        if (coldStart) {
                            if (((_b = (_a = window.performance) === null || _a === void 0 ? void 0 : _a.getEntriesByType('navigation')) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                                ((_c = window.performance) === null || _c === void 0 ? void 0 : _c.timeOrigin)) {
                                const newPageEntry = getColdStartPageLatency(pageEntry);
                                if (newPageEntry) {
                                    pageEntryDuration = newPageEntry.duration;
                                }
                            }
                            else {
                                coldStart = false;
                            }
                        }
                        const summary = {
                            pageDuration: pageEntryDuration,
                            requestDuration: requestEntry === null || requestEntry === void 0 ? void 0 : requestEntry.duration,
                            renderDuration: renderEntry === null || renderEntry === void 0 ? void 0 : renderEntry.duration,
                        };
                        reportPagePerformance(store.getState().Authentication, deeplink, isCreateAndBind, summary, coldStart);
                    }
                    Performance.clearMarks(`create:${templateId}`);
                    Performance.clearMarks(`bind:${templateId}`);
                    Performance.clearMarks(`createAndBind:${templateId}`);
                    Performance.clearMeasures();
                }
                recordPageView(deeplink);
            }
            break;
        case URL_CHANGE:
            Performance.clearMarks();
            Performance.clearMeasures();
            break;
        default:
            break;
    }
};
function getColdStartPageLatency(pageEntry) {
    var _a, _b;
    const navPref = (_a = window.performance) === null || _a === void 0 ? void 0 : _a.getEntriesByType('navigation')[0];
    const reqStartTime = ((_b = window.performance) === null || _b === void 0 ? void 0 : _b.timeOrigin) + navPref.requestStart;
    const coldStartPageLatency = new Date().getTime() - reqStartTime;
    const newPageEntry = {
        duration: coldStartPageLatency,
        entryType: pageEntry.entryType,
        name: pageEntry.name,
        startTime: pageEntry.startTime,
        toJSON() { },
    };
    return newPageEntry;
}
